export const environment = {
  production: false,
  apiUrl: "https://zeeia-api-dev.zeeway.com.br/api",
  supportPhone: '553788271596'
};
